import {
  Avatar,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Stack,
  SvgIcon,
  Tooltip,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import BlockIcon from "@mui/icons-material/Block";
// import { Scrollbar } from "../scrolbar";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import User01Icon from "@untitled-ui/icons-react/build/esm/User01";
import { useSelector } from "react-redux";
import theme from "../../config/theme";
import { selectGlobalState } from "../../state-management/selectors";

const renderContent = (notifications: any, mode: any, usersData: any) => {
  const createdAt = format(notifications.created_at, "MMM dd, h:mm a");
  const { description, title } = notifications;
  const user = usersData?.find(
    (item: any) => item._id === notifications.created_by
  );
  return (
    <>
      <ListItemAvatar sx={{ mt: 0.5 }}>
        <Avatar>
          {user ? (
            <div className="cursor-pointer">
              <img src={user.picture} alt="personal_picture" />
            </div>
          ) : (
            <SvgIcon>
              <User01Icon />
            </SvgIcon>
          )}
        </Avatar>
      </ListItemAvatar>

      <ListItemText
        primary={
          <Box
            sx={{
              alignItems: "center",
              flexWrap: "wrap",
            }}
            fontFamily={"inherit"}
          >
            <Typography
              sx={{ mr: 0.5 }}
              variant="subtitle2"
              fontFamily={mode.fontFamily.normal}
              color={mode.color.textPrimary}
            >
              {title}
            </Typography>
            <Typography
              sx={{ mr: 0.5 }}
              fontFamily={mode.fontFamily.normal}
              fontSize={11}
            >
              {description}
            </Typography>
          </Box>
        }
        secondary={
          <Typography color={mode.color.textSecondary} variant="caption">
            {createdAt}
          </Typography>
        }
        sx={{ my: 0 }}
      />
    </>
  );
};

function NotificationsDataPopover(props: any) {
  const {
    anchorEl,
    notifications,
    onClose,
    onMarkAllAsRead,
    onRemoveOne,
    open = false,
    ...other
  } = props;
  const themeMode = useSelector((state: any) => state.globalState.theme);
  const { usersData } = useSelector(selectGlobalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;
  const isEmpty = notifications?.length === 0;
  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: "left",
        vertical: "bottom",
      }}
      disableScrollLock
      container={document.body}
      onClose={onClose}
      open={open}
      {...other}
      sx={{ position: "absolute" }}
    >
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        spacing={2}
        sx={{
          px: 2,
          py: 2,
          backgroundColor: mode.backgroundColor.bgPrimary,
          color: mode.color.textPrimary,
        }}
      >
        <Typography variant="h6" fontFamily="inherit">
          اعلانات
        </Typography>
        <Tooltip
          title="حذف تمامی اعلانات"
          sx={{ fontFamily: mode.fontFamily.normal }}
        >
          <IconButton onClick={onMarkAllAsRead} size="small" color="inherit">
            <SvgIcon>
              <BlockIcon />
            </SvgIcon>
          </IconButton>
        </Tooltip>
      </Stack>
      {isEmpty ? (
        <Box
          sx={{
            backgroundColor: mode.backgroundColor.bgPrimary,
            color: mode.color.textPrimary,
            fontFamily: mode.fontFamily.normal,
            paddingY: 3,
            paddingX: 4,
          }}
        >
          <Typography variant="subtitle2" fontFamily="inherit">
            اعلاناتی وجود ندارد
          </Typography>
        </Box>
      ) : (
        <List
          disablePadding
          sx={{
            maxHeight: 400,
            overflowY: "auto",
            backgroundColor: mode.backgroundColor.bgPrimary,
            color: mode.color.textPrimary,
          }}
        >
          {notifications
            ?.slice()
            .sort(
              (a: any, b: any) =>
                new Date(b.created_at).getTime() -
                new Date(a.created_at).getTime()
            )
            .map((noti: any) => (
              <ListItem
                divider
                key={noti._id}
                sx={{
                  alignItems: "flex-start",
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                  "& .MuiListItemSecondaryAction-root": {
                    top: "50%",
                  },
                  borderLeft: "5px solid",
                  borderColor:
                    noti.type === "create"
                      ? mode.backgroundColor.bgSuccess
                      : noti.type === "edit"
                      ? mode.backgroundColor.bgWarning
                      : mode.backgroundColor.bgDanger,
                  borderBottom: `5px solid ${mode.backgroundColor.bgSecondary}`,
                  borderTop: `5px solid ${mode.backgroundColor.bgSecondary}`,
                }}
                secondaryAction={
                  <Tooltip title="Remove">
                    <IconButton
                      edge="end"
                      onClick={() => onRemoveOne?.(noti._id)}
                      size="small"
                      color="inherit"
                    >
                      <SvgIcon>
                        <XIcon />
                      </SvgIcon>
                    </IconButton>
                  </Tooltip>
                }
              >
                {renderContent(noti, mode, usersData)}
              </ListItem>
            ))}
        </List>
      )}
    </Popover>
  );
}
export default NotificationsDataPopover;
